const STATUS_STYLES = {
  Healthy: "border-emerald-200 bg-emerald-50 text-emerald-700",
  Degraded: "border-amber-200 bg-amber-50 text-amber-700",
  Failing: "border-rose-200 bg-rose-50 text-rose-700",
  NoData: "border-slate-200 bg-slate-100 text-slate-700",
};

function normalizeStatus(status) {
  return STATUS_STYLES[status] ? status : "NoData";
}

export default function WebhookHealthBadge({ status }) {
  const value = normalizeStatus(status);

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${STATUS_STYLES[value]}`}
    >
      {value}
    </span>
  );
}
